const loadMarketoForm = require("../marketo/loadMarketoForm");
const copyFormDataIntoMarketoForm = require("../marketo/copyFormDataIntoMarketoForm");
const removeMarketoFormEmbed = require("../marketo/removeMarketoFormEmbed");
const logRoiGateFormSubmissionFailure = require("./logRoiGateFormSubmissionFailure");
const saveRoiGateFormReturningUserData = require("./saveRoiGateFormReturningUserData");
const logRoiGateFormSubmissionSuccess = require("./logRoiGateFormSubmissionSuccess");
const submitMarketoForm = require("../marketo/submitMarketoForm");
const saveRoiGateFormData = require("./saveRoiGateFormData");
const logRoiGateFormSubmissionStart = require("./logRoiGateFormSubmissionStart");
const shouldBlockEmailDomainSilently = require("../validation/shouldBlockEmailDomainSilently");
const triggerRoiGateFormSubmitGoogleAnalyticsEvent = require("./triggerRoiGateFormSubmitGoogleAnalyticsEvent");
const identifyInHeap = require("../heap/identifyInHeap");

/**
 * @param roiGateFormData {RoiGateFormData}
 * @return {void}
 * @throws {Error}
 */
module.exports = async function submitRoiGateFormData(roiGateFormData) {
    void logRoiGateFormSubmissionStart(roiGateFormData);

    if (!shouldBlockEmailDomainSilently(roiGateFormData["Email"])) {
        triggerRoiGateFormSubmitGoogleAnalyticsEvent();

        identifyInHeap(roiGateFormData["Email"]);

        /**
         * @type {undefined | HTMLElement}
         */
        let marketoFormContainer;
        try {
            const marketoFormElements = await loadMarketoForm(roiGateFormData["formid"]);

            const marketoForm = marketoFormElements.marketoForm;
            marketoFormContainer = marketoFormElements.marketoFormContainer;

            copyFormDataIntoMarketoForm(marketoForm, roiGateFormData);

            await submitMarketoForm(marketoForm);

            saveRoiGateFormReturningUserData(roiGateFormData);

            saveRoiGateFormData(roiGateFormData);

            await logRoiGateFormSubmissionSuccess(roiGateFormData);
        } catch (e) {
            void logRoiGateFormSubmissionFailure(roiGateFormData);

            throw e;
        } finally {
            if (marketoFormContainer) {
                removeMarketoFormEmbed(marketoFormContainer);
            }
        }
    }
}
